module.exports = __webpack_public_path__ + "static/media/logoAetna.3b13e784.png";